import { TextStyle } from "./common";
const baseCaptionData = {};
const CaptionData = {
  fromJSON(object) {
    const message = { ...baseCaptionData };
    message.textStyle = object.textStyle !== void 0 && object.textStyle !== null ? TextStyle.fromJSON(object.textStyle) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.textStyle !== void 0 && (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : void 0);
    return obj;
  }
};
export {
  CaptionData
};
//# sourceMappingURL=node_caption.js.map
